import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './SettingsCard.module.scss'

const SettingsCard = ({ eyebrow, children }) => (
  <section className={classNames('d-flex flex-column', classes.card)}>
    <span className={classes.eyebrow}>{eyebrow}</span>
    {children}
  </section>
)

SettingsCard.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default SettingsCard
